export function commit(type: string, ...args: unknown[]) {
  window.plausible(type, ...args);
}
